import React, { useState } from 'react';
import './AddButton.css';

// const AddButtonSecond = ({ addoptions = [], onOptionSelect }) => {
//   const [selectedOption, setSelectedOption] = useState(null);
//   const [isOpen, setIsOpen] = useState(false);

//   const handleOptionClick = (option) => {
//     setSelectedOption(option);
//     setIsOpen(false); 
//     onOptionSelect(option);
//   };

//   return (
//     <div className="sort-container">
//       <div className="custom-dropdown-add">
//         <div className="new-old">

//           <button
//             className={`add-blue-button-second add-blue-button common-text fts-15 ftw-4 white ${isOpen ? 'rotate-arrow' : ''}`}
//             onClick={() => setIsOpen(!isOpen)} 
//           >
//             + New <span className="arrow-symbol">▼</span>
//           </button>

//         </div>
//         {isOpen && (
//           <div className="add-options">
//             {Array.isArray(addoptions) && addoptions.length > 0 ? (
//               addoptions.map((option, index) => (
//                 <div key={index} onClick={() => handleOptionClick(option)} className="option-item-container">
//                   <p
//                     className={`option-item dk-gray fts-15 common-text ${selectedOption === option ? 'selectedadd' : ''}`} 
                    
//                   >
//                     {option}
//                   </p>
//                   <img src="assets/plus.png" alt="logo" className='add-button-plus-img' />
//                 </div>
//               ))
//             ) : (
//               <p className="no-options">No options available</p> 
//             )}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddButtonSecond;



const AddButtonSecond = ({ addoptions = [], onOptionSelect }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    onOptionSelect(option);
  };

  return (
    <div className="sort-container">
      <div className="custom-dropdown-add">
        <div className="new-old">
          <button
            className={`add-blue-button-second add-blue-button common-text fts-15 ftw-4 white ${isOpen ? 'rotate-arrow' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
          >
            + New <span className="arrow-symbol">▼</span>
          </button>
        </div>
        {isOpen && (
          <div className="add-options">
            {Array.isArray(addoptions) && addoptions.length > 0 ? (
              addoptions.map((option, index) => (
                <div key={index} onClick={() => handleOptionClick(option)} className="option-item-container">
                  <p
                    className={`option-item dk-gray fts-15 common-text ${selectedOption === option ? 'selectedadd' : ''}`}
                  >
                    {option}
                  </p>
                  <img src="assets/plus.png" alt="logo" className='add-button-plus-img' />
                </div>
              ))
            ) : (
              <p className="no-options">No options available</p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
export default AddButtonSecond;